<div class="modal fade" bsModal #recordsModal="bs-modal" [config]="{backdrop: 'static'}"
     tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-sm">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title pull-xs-left">{{title}}</h4>
                <button type="button" class="close float-sm-right" aria-label="Close" (click)="closeModal()">
                    <span aria-hidden="true"><img src="assets/img/icon-close-reversed.png"></span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row" style="margin-left:0px">
                    <div> 
                        Date Range
                    </div>
                    <div>
                        <my-date-range-selector [defaultStartDate]="startDate"
                                                [defaultEndDate]="endDate"
                                                [skipDataStore]="true"
                                                [maxDate]="maxDate"
                                                (selectedChange)="onDateRangeSelection($event)"
                                                (dateRangeValidated)="onDateRangeValidated($event)">
                        </my-date-range-selector>
                    </div>
                    <div *ngIf="!isValidDateRange">
                        <br><br>
                        <em>Please enter a valid date range.</em>
                    </div>
                </div>                
                <div class="row" style="margin:0px" >
                    <div>
                        Select an Invoice Group:
                    </div>
                    <div>
                        <input type="search" [(ngModel)]="searchText" (ngModelChange)="searchInvoiceGroups($event)" placeholder="Search" style="width: 330px; margin-bottom: 10px">
                    </div>
                    <div class="invoice-group-content-area">
                        <div class="col-12" *ngIf="isLoadingInvoiceGroups">
                            <img src="assets/img/loading.gif" height="96" width="96"><br>
                        </div>
                        <div *ngFor="let invoiceGroup of filteredInvoiceGroups">
                            <label class="radio">
                                <input type="radio" 
                                        name="invoiceGroups"
                                        (change)="selectInvoiceGroup(invoiceGroup)"
                                        [(ngModel)]="selectedInvoiceGroup"
                                        [value]="invoiceGroup"><span></span>
                                {{invoiceGroup.Description}}
                            </label>
                        </div>
                    </div>
                </div>
                <hr>
                <div class="row" style="margin:0px" >
                    <span class="modal-sub-header">Sort by:</span>

                    <div *ngFor="let sortOrder of sortOrderEnums">
                        <label class="radio">
                            <input type="radio" 
                                   name="sortBy"
                                   (change)="selectSortOrder(sortOrder)"
                                   [(ngModel)]="selectedSortOrder"
                                   [value]="sortOrder"><span></span>
                            {{getDisplayNameForEnum(sortOrder)}}
                        </label>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <div class="float-left text-align-left">
                    <button class="btn btn-primary" (click)="closeModal()">Cancel</button>
                </div>
                <div class="float-right text-align-right">
                    <button (click)="generateContent()"
                            [disabled]="!canGenerateReport()"
                            class="btn btn-primary">
                        <img src="assets/img/loading.gif" height="25" width="25" [hidden]="hideSpinner">Download</button>
                </div>
            </div>
        </div>
    </div>
</div>